export default {"src":"/_next/static/media/UVE.8b447837.svg","height":18,"width":18};